import { render, staticRenderFns } from "./JciTrainersList.vue?vue&type=template&id=8783e3ec&scoped=true"
import script from "./JciTrainersList.vue?vue&type=script&lang=js"
export * from "./JciTrainersList.vue?vue&type=script&lang=js"
import style0 from "./JciTrainersList.vue?vue&type=style&index=0&id=8783e3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8783e3ec",
  null
  
)

export default component.exports